import type Quill from 'quill/core';
import { useEffect, useRef } from 'react';

type Handler = () => void;

const useEditorWidthChange = (quill: Quill | undefined, handler: Handler) => {
  const handlerRef = useRef<Handler>(handler);
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!quill?.root) return undefined;

    let lastWidth: number | null = null;
    const observer = new ResizeObserver((entries) => {
      const { width } = entries[0]?.contentRect || {};
      if (width !== lastWidth) {
        if (lastWidth !== null) {
          handlerRef.current();
        }
        lastWidth = width ?? null;
      }
    });

    observer.observe(quill.root);
    return () => {
      observer.disconnect();
    };
  }, [quill]);
};

export default useEditorWidthChange;
